import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MergedMerchantModel } from './types'

interface MerchantState {
  merchant: MergedMerchantModel | null
  loading: boolean
  error: string | null
  isVerified: boolean
}

const initialState: MerchantState = {
  merchant: null,
  loading: false,
  error: null,
  isVerified: false,
}

const merchantSlice = createSlice({
  name: 'merchant',
  initialState,
  reducers: {
    fetchMerchantStart: (state) => {
      state.loading = true
      state.error = null
    },
    fetchMerchantSuccess: (state, action: PayloadAction<MergedMerchantModel>) => {
      state.merchant = action.payload
      state.loading = false
      state.isVerified = action.payload.isVerified
    },
    fetchMerchantFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
  },
  selectors: {
    selectMerchant: (state) => state.merchant,
    selectIsMerchantLoading: (state) => state.loading,
    selectIsMerchantVerified: (state) => state.isVerified,
    selectMerchantError: (state) => state.error,
  },
})

export const { fetchMerchantStart, fetchMerchantSuccess, fetchMerchantFailure } =
  merchantSlice.actions
export const {
  selectIsMerchantLoading,
  selectMerchant,
  selectMerchantError,
  selectIsMerchantVerified,
} = merchantSlice.selectors
export default merchantSlice.reducer
